module.exports = __webpack_public_path__ + "static/one-d58d0485f04414d03051f22b5add82f0.png";